import dayjs from 'dayjs';

// Generates grouped date labels for a given total number of days and group size.
export function generateGroupedDateLabels(totalDays = 30, groupSize = 7) {
  const yesterday = dayjs().subtract(1, 'day');
  const labels = [];

  const groups = Math.ceil(totalDays / groupSize);

  for (let g = groups - 1; g >= 0; g--) {
    const startOffset = g * groupSize + groupSize - 1;
    const endOffset = g * groupSize;

    const start = yesterday.subtract(Math.min(startOffset, totalDays - 1), 'day');
    const end = yesterday.subtract(endOffset, 'day');

    labels.push(`${start.format('MMM D')} - ${end.format('MMM D')}`);
  }

  return labels;
}

// Generates consecutive date labels for a given total number of days.
export function generateConsecutiveDateLabels(totalDays = 30) {
  const yesterday = dayjs().subtract(1, 'day');
  const labels = [];

  for (let i = totalDays - 1; i >= 0; i--) {
    labels.push(yesterday.subtract(i, 'day').format('YYYY-MM-DD'));
  }

  return labels;
}
